module.exports = __webpack_public_path__ + "img/cooperative0_logo2.25c86a77.jpg";